export default "<m-image\n    src=\"https://public.mml.io/test-image.jpg\"\n    x=\"3\"\n    y=\"5\"\n    z=\"3\"\n    width=\"5\"\n></m-image>\n";